import React from "react";
import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";
import loadContent from "core-module/hoc/loadContent";

import EmergencyProfilesSummaryCard from "./911ProfilesSummaryCard.jsx";
import PhoneBasicSettingsCard from "./BasicSettingsCard.jsx";
import VoicemailSettingsCard from "./VoicemailSettingsCard.jsx";
import CallsHistoryCard from "./CallsHistoryCard.jsx";
import LongDistanceBalanceCard from "./InternationalAllowanceBalanceCard.jsx";
import LongDistanceHistoryCard from "./InternationalAllowanceHistoryCard.jsx";
import PhoneAdvancedSettingsCard from "./AdvancedSettingsCard.jsx";

const PhoneByBillingpackage = props => {
  if (props.shouldRender === "911Profile") {
    return (
      <GridContainer justify="center">
        <GridItem xs={12}>
          <EmergencyProfilesSummaryCard
            pathids={{ billingpackage: props.ids.billingpackage }}
            onClickEdit={props.editEmergencyProfile}
            onClickDelete={props.deleteEmergencyProfile}
            emergencyProfileType={props.emergencyProfileType}
            selectEmergencyProfile={props.selectEmergencyProfile}
            selectDnWizard={props.selectDnWizard}
          />
        </GridItem>
      </GridContainer>
    );
  }
  if (props.shouldRender === "BasicSettings") {
    return (
      <GridContainer justify="center">
        <GridItem xs={12} md={6}>
          <PhoneBasicSettingsCard
            pathids={{ billingpackage: props.ids.billingpackage }}
            onClickEditBasicSettings={props.onClickEditBasicSettings}
          />
        </GridItem>
        <GridItem xs={12} md={6}>
          <VoicemailSettingsCard
            pathids={{ billingpackage: props.ids.billingpackage }}
            onClickEditVoicemailSettings={props.onClickEditVoicemailSettings}
          />
        </GridItem>
      </GridContainer>
    );
  }
  if (props.shouldRender === "CallHistory") {
    return (
      <GridContainer justify="center">
        <GridItem xs={12}>
          <CallsHistoryCard
            pathids={{ billingpackage: props.ids.billingpackage }}
          />
        </GridItem>
      </GridContainer>
    );
  }

  if (props.shouldRender === "InternationalAllowance") {
    return (
      <GridContainer justify="center">
        <GridItem xs={12} md={6}>
          <LongDistanceBalanceCard
            pathids={{ billingpackage: props.ids.billingpackage }}
            onClickLongDistanceBalanceAdd={props.onClickLongDistanceBalanceAdd}
          />
        </GridItem>
        <GridItem xs={12} md={6}>
          <LongDistanceHistoryCard
            pathids={{
              billingpackage: props.ids.billingpackage
            }}
          />
        </GridItem>
      </GridContainer>
    );
  }

  if (props.shouldRender === "AdvancedSettings") {
    return (
      <GridContainer justify="center">
        <GridItem xs={12}>
          <PhoneAdvancedSettingsCard
            pathids={{
              billingpackage: props.ids.billingpackage
            }}
            onClickEditPhoneAdvancedSettings={
              props.onClickEditPhoneAdvancedSettings
            }
          />
        </GridItem>
      </GridContainer>
    );
  }
  return null;
};

export default loadContent(
  "user.session/billingpackage.props/billingpackageservice_voip",
  PhoneByBillingpackage
);
